import { render, staticRenderFns } from "./InboxItemSource.vue?vue&type=template&id=702db239&scoped=true&"
import script from "./InboxItemSource.vue?vue&type=script&lang=js&"
export * from "./InboxItemSource.vue?vue&type=script&lang=js&"
import style0 from "./InboxItemSource.vue?vue&type=style&index=0&id=702db239&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702db239",
  null
  
)

export default component.exports